import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { map, Observable } from 'rxjs';
import * as Helper from '../helpers/http.helper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Paged } from '../models/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  path: string = 'User';
  updatableProperties: string[] = ['firstName', 'lastName', 'status', 'email'];

  constructor(protected http: HttpClient) {}

  getSingle(id: string): Observable<User> {
    return Helper.getSingleModel(this.http, this.path, id);
  }

  getAll(
    pageNumber?: number,
    pageSize?: number,
    queryParameters?: Map<string, any>
  ): Observable<any> {
    var paged = Helper.getPaged<User>(
      this.http,
      this.path,
      pageNumber,
      pageSize,
      this.buildQueryParameters(queryParameters)
    );

    return paged.pipe(
      map((data) => {
        return {
          countRequested: data.PageSize,
          pageIndex: data.CurrentPage,
          items: data.data,
          totalCount: data.TotalCount,
        };
      })
    );
  }

  getPaged(
    page: number,
    size: number,
    queryParameters: Map<string, any>
  ): Observable<Paged<User>> {
    return Helper.getPaged<User>(
      this.http,
      this.path,
      page,
      size,
      this.buildQueryParameters(queryParameters)
    );
  }

  create(body: User): Observable<User> {
    return Helper.createMdoel(this.http, this.path, body);
  }

  userCreatedByAdmin(body: any) {
    const path = '/api/User';
    return this.http.post(`${environment.API}${path}/AdminCreatesUser`, body);
  }

  update(body: User): Observable<User> {
    return Helper.updateModel(
      this.http,
      this.path,
      this.updatableProperties,
      body
    );
  }

  delete(id: string): Observable<boolean> {
    return Helper.deleteModel(this.http, this.path, id);
  }

  forgotPassword(email: string): Observable<any> {
    const path = '/api/User';
    return this.http.post(
      `${environment.API}${path}/ForgotPassword`,
      { email: email },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += '&' + entry[0] + '=' + val;
        }

        queryString = queryString.substring(0, queryString.length - 1);
      } else {
        queryString += '&' + entry[0] + '=' + queryParameters.get(entry[0]);
      }
    }

    return queryString;
  }
}
